import { Box, Button, IconButton, Tab, Tabs } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import CustomPagination from "components/Panigation";
import SearchBar from "components/SearchBar";
import TableComponent from "components/TableComponent";
import dayjs from "dayjs";
import { showError } from "helpers";
import MainContainer from "layout/MainContainer";
import { ConfirmationModal } from "Modals/confirmationModal";
import ResonOfRejection from "Modals/reasonOfRejection";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useLazyGetBookingsQuery } from "service/booking";
import { Listing } from "types/General";
import { isValidInput } from "utils/validations";

enum BOOKING_STATUS {
  PENDING = 1,
  ONGOING = 2,
  CONFIRMED = 3,
  CANCELLED = 4,
  COMPLETED = 5,
  FAILED = 6,
}

const Bookings = () => {
  const navigate = useNavigate();
  const [getBookings] = useLazyGetBookingsQuery();

  const [searchTerm, setSearchTerm] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [selectedId, setSelectedId] = useState("");
  const [open, setOpen] = useState(false);
  const [modalType, setModalType] = useState("");
  const [rejectionOpen, setRejectionOpen] = useState<boolean>(false);
  const [rejectionRsn, setRejectionRsn] = useState<string>("");
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [bookings, setBookings] = useState<any[]>([]);

  const [page, setPage] = useState<number>(1);

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const columns: GridColDef[] = [
    {
      flex: 0.6,
      minWidth: 100,
      field: "booking",
      headerName: "Booking Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="sq_image" style={{ marginTop: "16px" }}>
            <figure style={{ cursor: "pointer" }} onClick={() => {}}>
              <img
                src={
                  row?.items[0]?.carDetails?.images[0] ||
                  "/static/images/picture.png"
                }
                alt="Vehicle"
              />
            </figure>
            <p>
              <b>{row?.items[0]?.carDetails?.title?.en || "-"}</b>
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.8,
      minWidth: 200,
      field: "user",
      headerName: "Customer Details",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure>
              <img src={"/static/images/user_placeholder.png"} alt="" />
            </figure>
            <p>
              <b>{`${row?.userDetails?.firstName || "-"} ${row?.userDetails?.lastName || ""}`}</b>
              {row?.userDetails?.countryCode || ""}{" "}
              {row?.userDetails?.phone || "-"} <br />
              {row?.userDetails?.email || "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 0.4,
      minWidth: 100,
      field: "price",
      headerName: "Price",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{`AED ${row?.totalAmount.toFixed(2) || "0"}`}</p>
          </div>
        );
      },
    },

    {
      flex: 0.6,
      minWidth: 200,
      field: "date",
      headerName: "Date & Time",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {`From: ${row?.items[0]?.rentalStart ? dayjs(row?.items[0]?.rentalStart).format("DD MMM, YYYY") : "-"}`}{" "}
              <br />{" "}
              {`To: ${row?.items[0]?.rentalEnd ? dayjs(row?.items[0]?.rentalEnd).format("DD MMM, YYYY") : "-"}`}{" "}
            </p>
          </div>
        );
      },
    },

    {
      flex: 0.4,
      minWidth: 100,
      field: "Status",
      headerName: "Status",
      editable: false,
      sortable: false,

      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {" "}
              {row?.status === BOOKING_STATUS.PENDING
                ? "Pending"
                : row?.status === BOOKING_STATUS.CONFIRMED
                  ? "Confirmed"
                  : row?.status === BOOKING_STATUS.COMPLETED
                    ? "Completed"
                    : row?.status === BOOKING_STATUS.FAILED
                      ? "Failed"
                      : row?.status === BOOKING_STATUS.CANCELLED
                        ? "Cancelled"
                        : "Approved"}
            </p>
          </div>
        );
      },
    },
    // {
    //   // flex: 1,
    //   minWidth: 200,
    //   field: "request",
    //   headerName: "Request",
    //   editable: false,
    //   sortable: false,
    //   renderCell: () => (
    //     <div className="user_block">
    //       <Button
    //         variant="outlined"
    //         sx={{
    //           color: "red",
    //           borderColor: "red",
    //           "&:hover": {
    //             backgroundColor: "rgba(255, 0, 0, 0.1)",
    //             borderColor: "darkred",
    //             color: "darkred",
    //           },
    //         }}
    //         size="small"
    //       >
    //         Reject
    //       </Button>
    //       <Button
    //         variant="outlined"
    //         sx={{
    //           color: "green",
    //           borderColor: "green",
    //           "&:hover": {
    //             backgroundColor: "rgba(0, 128, 0, 0.1)", // light green background on hover
    //             borderColor: "darkgreen",
    //             color: "darkgreen",
    //           },
    //         }}
    //         size="small"
    //       >
    //         Approve
    //       </Button>
    //     </div>
    //   ),
    // },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => (
        <div className="table_actions v2">
          <Box>
            <IconButton
              onClick={() => navigate(`/bookings/details/${row?._id}`)}
            >
              <img src="/static/images/eye_icon.svg" alt="" />
            </IconButton>
          </Box>

          {/* <Box>
            <IconButton>
              <img src="/static/images/trash2_icon.svg" alt="" />
            </IconButton>
          </Box> */}
        </div>
      ),
    },
  ];

  const getBookingsApi = async () => {
    setLoading(true);
    try {
      const response = await getBookings({
        page: page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setBookings(response?.data?.bookings || []);
        setCount(response?.data?.totalCount);
        setPage(response?.data?.currentPage);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getBookingsApi();
  }, [page, debouncedSearchTerm]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Bookings</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Bookings
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <div className="table_header">
            <div className="left_s">
              <Box className="search_box">
                <SearchBar
                  searchTerm={searchTerm}
                  placeholder="Search"
                  setDebouncedSearchTerm={setDebouncedSearchTerm}
                  value={searchTerm}
                  onCross={() => setSearchTerm("")}
                  onChange={(val: any) => {
                    if (isValidInput(val.target.value)) {
                      setSearchTerm(val.target.value);
                    }
                  }}
                />
              </Box>
            </div>
            <div className="right_s">
              <Box>
                <Button className="btn btn_highlight">
                  <img src="/static/images/upload_icon.svg" alt="Icon" /> Export
                  CSV
                </Button>
              </Box>
            </div>
          </div>

          <div className="sorting_table">
            <TableComponent
              columns={columns}
              rows={bookings}
              count={count}
              page={page}
              onPageChange={handlePageChange}
              loading={loading}
            />

            {bookings?.length ? (
              <CustomPagination
                currentPage={page - 1}
                totalPages={Math.ceil(count / 10)}
                count={count}
                pageSize={10}
                onPageChange={(page) => setPage(page + 1)}
              />
            ) : null}
          </div>
        </Box>

        <ResonOfRejection
          selectedId={selectedId}
          rejectionRsn={rejectionRsn}
          setRejectionRsn={setRejectionRsn}
          open={rejectionOpen}
          setOpen={setRejectionOpen}
          onClose={() => {}}
        />

        <ConfirmationModal
          text={
            modalType === "delete"
              ? "Are you sure to delete this listing?"
              : modalType === "accept"
                ? "Are you sure to approve this listing?"
                : modalType === "reject"
                  ? "Are you sure to reject this listing?"
                  : ""
          }
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => {}}
        />
      </div>
    </MainContainer>
  );
};

export default Bookings;
